import { IRequesterInfo } from "../../base/models"
import { ClientProxy } from "../../base/proxy/clientProxy"

export class SendErrorApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'MyReports/PaymentFrontEndErrorLogs',
      requesterInfo,
    })
  }

  public async sendError(request: string): Promise<boolean> {
    return await this.postAsync<boolean>(request)
  }
}
